import React from 'react'
import {useHistory, useLocation} from 'react-router-dom'
import { withStyles } from 'external/material';
import Pagination from '@mui/material/Pagination'
import PaginationItem from '@mui/material/PaginationItem'

const QuizPagination = withStyles((theme) => ({
  ul: {
    justifyContent: 'center'
  }
}))(Pagination)

const QuizPaginationItem = withStyles((theme) => ({
  root: {
    color: '#4f576e',
    fontSize: '12pt',
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(1),
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      borderRadius: 3,
    },
  },
  outlined: {
    backgroundColor: '#fff',
    borderRadius: 3,
    border: 'solid 1px #909ebb'
  },
  page: {
  },
  selected: {
    borderRadius: 3,
    backgroundColor: '#c9f1fd !important'
  }
}))(PaginationItem)

export default function QuizPaginationComponent({context, page, count}) {

  const history = useHistory()
  const location = useLocation()

  const handleChange = (event, page) => {
    history.push(context.linkQuery(location.pathname, {...context.query, page}))
  }

  return (
      <QuizPagination
        count={count}
        page={page}
        onChange={handleChange}
        renderItem={item => {
          const variant = ['next', 'previous'].indexOf(item.type) >= 0 ? 'outlined' : 'text'
          return  (<QuizPaginationItem {...{...item, variant}} />)
        }}
      />
  )
}
